import React from "react";
import { Typography, TypographyProps } from "@mui/material";

interface SectionTitleProps extends Omit<TypographyProps, "variant"> {
  children: React.ReactNode;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ children, sx, ...props }) => {
  return (
    <Typography
      {...props}
      sx={{
        color: "#FFFFFF",
        fontSize: "23px",
        fontWeight: 400,
        textTransform: "lowercase",
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};

export default SectionTitle;
